module.exports = __webpack_public_path__ + "img/iconFaHuoRenWu.8b9b6583.svg";